/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum FieldLengths {
    UsernameLength = 256,
    PasswordLength = 128,
    MfaCode = 6,
}
